/**
 * The state machine documents, extraction runs and categorisation runs all
 * share. Mirrors public.is_processing_status_transition_allowed.
 */
export enum ProcessingStatus {
  Pending = 'pending',
  Deferred = 'deferred',
  Processing = 'processing',
  Processed = 'processed',
  Failed = 'failed',
  Rejected = 'rejected',
}
